import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import * as workerTimers from "worker-timers";
import "./timer.css";
import Authapi from "../../Services/Authapi";
import swal from 'sweetalert';
import PremiumButton from "../../Layouts/PremiumButton";
import { toast } from 'react-toastify';
import ls from "local-storage";
import config from "../../../Config";
import {
  clearAutoTimerMode,
  clearAutoTimerRuntimeState,
  clearAutoTimerSessionStartedAt,
  dispatchAutoTimerExtensionSync,
  ensureAutoTimerSessionStartedAt,
  getAutoTimerMode,
  setAutoTimerRuntimeState,
  setAutoTimerMode,
  setAutoTimerSessionStartedAt,
  subscribeToAutoTimerExtensionEvents,
} from "../../../utils/autoTimerExtension";

class Timer extends Component {
  constructor(props) {

    super(props);
    this.state = {
      timer: 0,
      totaltimer: 0,
      isActive: false,
      isPaused: false,
      startTime: 0,
      stopTime: 0,
      isLoading: false,
      isInitialLoading: true,
      autoTimerOffMinutes: 0,
      autoTimerMode: "at_work",
    };
    this.countRef = React.createRef(null);
    this.extensionUnsubscribe = null;
  }

  async componentDidMount() {
    // console.log(this.props.user.Notification_Status);
    //     if (this.props.user.Notification_Status === 1) {
    //       setInterval(() => {
    //         this.breaktimeremainder()
    //       }, 300000)  // 5 minit 
    //     }

    // Check duration and auth status independently to ensure no blocking
    // Check duration first and wait for it to complete to establish 'isActive' state
    await this.checkDuration();
    await this.loadAutoTimerOffConfig();
    this.setupAutoTimerExtensionBridge();
    this.syncAutoTimerExtensionState();
    this.setupBreakNotification();
    this.checkTotalTimer();

    this.taskDeadlineInterval = setInterval(async () => {
      try {
        await Authapi.notifyTasksDeadlinePassed();
      } catch (error) {
        console.error("Error notifying task deadlines:", error);
      }
    }, 120000); // 120000 milliseconds = 2 minutes

    window.addEventListener("beforeunload", this.handleComponentUnmount.bind(this));
  }

  checkDuration = async () => {
    try {
      let timeCount = await Authapi.durTime(this.props.user.id);
      const totalDurationInSec = parseInt(timeCount.totalDurationInSec, 10);

      if (totalDurationInSec > 0) {
        ensureAutoTimerSessionStartedAt();
        this.setState(
          {
            timer: totalDurationInSec,
            isActive: true,
            isInitialLoading: false,
            autoTimerMode: getAutoTimerMode(),
          },
          this.runCycle
        );
      } else {
        clearAutoTimerMode();
        clearAutoTimerRuntimeState();
        clearAutoTimerSessionStartedAt();
        this.setState({ isInitialLoading: false, autoTimerMode: "at_work" });
      }
    } catch (error) {
      console.error("Error fetching duration time:", error);
      this.setState({ isInitialLoading: false });
    }
  }

  loadAutoTimerOffConfig = async () => {
    try {
      const response = await Authapi.getUserWorkingHours(this.props.user.id);
      if (response && response.status) {
        this.setState({
          autoTimerOffMinutes: Number(response.auto_timer_off_minutes || 0),
        });
      }
    } catch (error) {
      console.error("Error fetching auto timer off config:", error);
    }
  };

  setupAutoTimerExtensionBridge = () => {
    this.extensionUnsubscribe = subscribeToAutoTimerExtensionEvents((detail) => {
      if (!detail || String(detail.userId) !== String(this.props.user.id)) {
        return;
      }

      if (detail.eventType === "auto_off_request") {
        this.handleAutoOffRequest(detail);
        return;
      }

      if (detail.eventType === "auto_off") {
        clearAutoTimerMode();
        clearAutoTimerRuntimeState();
        clearAutoTimerSessionStartedAt();
        workerTimers.clearInterval(this.countRef.current);
        this.setState({
          isActive: false,
          isLoading: false,
          stopTime: Date.now(),
          autoTimerMode: "at_work",
        });
        toast.error(detail.message || "Auto timer off triggered.", { autoClose: 2000 });
        setTimeout(() => {
          window.location.reload();
        }, 1800);
      }
    });
  };

  handleAutoOffRequest = async (detail) => {
    if (!this.state.isActive || this.state.isLoading) {
      return;
    }

    this.setState({ isLoading: true });

    try {
      await Authapi.outTime();
      clearAutoTimerMode();
      clearAutoTimerRuntimeState();
      clearAutoTimerSessionStartedAt();
      workerTimers.clearInterval(this.countRef.current);
      this.setState(
        {
          isActive: false,
          isLoading: false,
          stopTime: Date.now(),
          autoTimerMode: "at_work",
        },
        () => {
          toast.error(detail?.message || "Auto timer off triggered.", { autoClose: 2000 });
          setTimeout(() => {
            window.location.reload();
          }, 1800);
        }
      );
    } catch (error) {
      this.setState({ isLoading: false });
      console.error("Error during auto timer off checkout:", error);
    }
  };

  syncAutoTimerExtensionState = () => {
    const authToken =
      ls.get("authToken") &&
      ls.get("authToken") !== null &&
      ls.get("authToken") !== false
        ? ls.get("authToken")
        : "";

    const payload = {
      token: authToken,
      userId: this.props.user?.id || "",
      isTimerActive: !!this.state.isActive,
      autoTimerOffMinutes: Number(this.state.autoTimerOffMinutes || 0),
      autoTimerMode: this.state.autoTimerMode || "at_work",
      appOrigin: typeof window !== "undefined" ? window.location.origin : "",
      apiUrl: config.apiurl,
      sessionStartedAt: this.state.isActive ? ensureAutoTimerSessionStartedAt() : null,
    };

    setAutoTimerRuntimeState(payload);
    dispatchAutoTimerExtensionSync(payload);
  };

  setupBreakNotification = async () => {
    try {
      const authResponse = await Authapi.checkAuth(this.props.user.id);
      if (authResponse && authResponse.data && authResponse.data.user && authResponse.data.user.Break_notification_status === 1) {
        // Clear any existing interval just in case
        if (this.breakTimerInterval) clearInterval(this.breakTimerInterval);

        this.breakTimerInterval = setInterval(() => {
          this.breaktimeremainder();
        }, 300000);  // Check every 5 minutes
        this.breaktimeremainder();
      }
    } catch (error) {
      console.error("Error checking auth status:", error);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleComponentUnmount.bind(this));
    workerTimers.clearInterval(this.countRef.current);
    clearInterval(this.taskDeadlineInterval);
    clearInterval(this.breakTimerInterval);
    if (this.extensionUnsubscribe) {
      this.extensionUnsubscribe();
      this.extensionUnsubscribe = null;
    }
  }

  async checkTotalTimer() {
    try {
      let timeCount = await Authapi.dureTime1(this.props.user.id);

      const totalDurationInSec = parseInt(timeCount.totalDurationInSec, 10);

      if (totalDurationInSec > 0) {
        this.setState({ totaltimer: totalDurationInSec }, this.runCycle1);
      } else {
        // this.setState({ isInitialLoading: false });
      }
    } catch (error) {
      console.error("Error fetching duration time:", error);
      // this.setState({ isInitialLoading: false });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.isActive !== this.state.isActive ||
      prevState.autoTimerOffMinutes !== this.state.autoTimerOffMinutes ||
      prevState.autoTimerMode !== this.state.autoTimerMode
    ) {
      this.syncAutoTimerExtensionState();
    }
  }

  handleComponentUnmount() {
    if (this.state.isActive) {
      Authapi.saveTime(this.state.timer);
    }
  }

  breaktimeremainder = async () => {
    if (!this.state.isActive) {
      const result = await Authapi.breaktimeremainder();

      if (result.status === true) {
        if (Notification.permission === "default") {
          Notification.requestPermission().then(permission => {
            if (permission === "granted") {
              new Notification("Notification", {
                body: result.message,
                icon: "/logo.png",
              });
            }
          });
        } else if (Notification.permission === "granted") {
          new Notification("Notification", {
            body: result.message,
            icon: "/logo.png",
          });
        }
      }
    } else {

    }
  };



  runCycle() {
    this.countRef.current = workerTimers.setInterval(() => {
      this.setState((prevState) => ({ timer: prevState.timer + 1 }));
    }, 1000);
  }

  runCycle1() {
    if (this.state.isActive === true) {
      this.countRef.current = workerTimers.setInterval(() => {
        this.setState((prevState) => ({ totaltimer: prevState.totaltimer + 1 }));
      }, 1000);
    }
  }

  handleStart = async () => {
    this.setState({ isLoading: true });
    await new Promise(resolve => setTimeout(resolve, 2000));

    try {
      await Authapi.inTime();
      setAutoTimerMode("at_work");
      setAutoTimerSessionStartedAt(Date.now());
      this.setState(
        {
          isActive: true,
          startTime: Date.now(),
          isLoading: false,
          autoTimerMode: "at_work",
        },
        () => {
          this.runCycle();
          this.runCycle1();
        }
      );

      toast.success("You marked IN");

    } catch (error) {
      this.setState({ isLoading: false });
      const responseData = error.response?.data;
      const errorMessage = responseData?.message || "An error occurred while clocking in.";

      // Attempt to extract detailed information
      let pendingLeaves = responseData?.pending_leaves || [];
      let totalDays = responseData?.total_pending_days || responseData?.pending_count || (Array.isArray(pendingLeaves) ? pendingLeaves.length : 0);
      let fromDate = responseData?.from_date;
      let toDate = responseData?.to_date;

      // Handle cases where information might be in the errorMessage but not explicitly in data fields
      if (!totalDays || !fromDate) {
        // Simple regex to find dates in DD-MM-YYYY or YYYY-MM-DD format
        const dateRegex = /(\d{2}-\d{2}-\d{4})|(\d{4}-\d{2}-\d{2})/g;
        const foundDates = errorMessage.match(dateRegex);
        if (foundDates) {
          if (!fromDate) fromDate = foundDates[0];
          if (!toDate) toDate = foundDates[foundDates.length - 1];
          if (!totalDays) totalDays = foundDates.length;
        }
      }

      // If we have an array of leaves, ensure from/to dates are set
      if (Array.isArray(pendingLeaves) && pendingLeaves.length > 0) {
        const first = pendingLeaves[0];
        const last = pendingLeaves[pendingLeaves.length - 1];
        if (!fromDate) fromDate = typeof first === 'string' ? first : first.date;
        if (!toDate) toDate = typeof last === 'string' ? last : last.date;
      }

      const showAddLeaveButton = errorMessage !== "You have already \"Clocked In\" today!! Please refresh the page.";
      const isPendingLeaveError = errorMessage.toLowerCase().includes("pending") || errorMessage.toLowerCase().includes("leave") || totalDays > 0;

      if (isPendingLeaveError && showAddLeaveButton) {
        // Fetch actual absent dates if they're missing from the error response
        if (!fromDate) {
          try {
            const today = new Date();
            let month = today.getMonth() + 1;
            let year = today.getFullYear();
            
            let attendanceRes = await Authapi.getAttendance(this.props.user.id, month, year);
            let absentDays = [];

            if (attendanceRes && attendanceRes.status && Array.isArray(attendanceRes.data)) {
              absentDays = attendanceRes.data.filter(day => day.status.toLowerCase() === 'absent');
            }

            // If no absent days this month, check last month too
            if (absentDays.length === 0) {
              month = month === 1 ? 12 : month - 1;
              year = month === 12 ? year - 1 : year;
              attendanceRes = await Authapi.getAttendance(this.props.user.id, month, year);
              if (attendanceRes && attendanceRes.status && Array.isArray(attendanceRes.data)) {
                absentDays = attendanceRes.data.filter(day => day.status.toLowerCase() === 'absent');
              }
            }

            if (absentDays.length > 0) {
              // Sort by date to get correct range
              absentDays.sort((a, b) => {
                const [da, ma, ya] = a.date.split('-').map(Number);
                const [db, mb, yb] = b.date.split('-').map(Number);
                return new Date(ya, ma - 1, da) - new Date(yb, mb - 1, db);
              });

              fromDate = absentDays[0].date;
              toDate = absentDays[absentDays.length - 1].date;
              totalDays = absentDays.length;
            }
          } catch (fetchError) {
            console.error("Error fetching attendance for popup:", fetchError);
          }
        }

        const content = document.createElement("div");
        content.className = "pending-leave-container";
        content.innerHTML = `
          <p class="pending-leave-message">Add Your Pending Leave.</p>
          <div class="pending-leave-card">
            <table class="pending-leave-table">
              <tr>
                <td class="pending-leave-label">Total Day(s):</td>
                <td class="pending-leave-value">${totalDays || '1'} Day</td>
              </tr>
              <tr>
                <td class="pending-leave-label">From Date:</td>
                <td class="pending-leave-value">${fromDate || 'N/A'}</td>
              </tr>
              <tr>
                <td class="pending-leave-label">To Date:</td>
                <td class="pending-leave-value">${toDate || fromDate || 'N/A'}</td>
              </tr>
            </table>
          </div>
          <p class="pending-leave-footer">Please submit a leave request for the above period to start timer!</p>
        `;

        swal({
          title: "Remaining Leave Alert",
          content: content,
          className: "pending-leave-modal",
          buttons: {
            cancel: {
              text: "Cancel",
              value: null,
              visible: true,
              className: "swal-cancel-btn",
              closeModal: true
            },
            add: {
              text: "Add Leave",
              value: "add",
              visible: true,
              className: "swal-add-leave-btn",
              closeModal: true
            }
          }
        }).then((value) => {
          if (value === "add") {
            this.props.history.push({
              pathname: "/leave-tickets/add",
              state: {
                date: fromDate,
                endDate: toDate,
                type: "Loss Of Pay",
                message: "Pending Leave"
              }
            });
          } else {
            window.location.reload();
          }
        });
      } else {
        swal({
          title: "Error",
          text: errorMessage,
          icon: "error",
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "gray-button",
              closeModal: true
            },
            ...(showAddLeaveButton && {
              add: {
                text: "Add Leave",
                value: "add",
                visible: true,
                className: "swal-add-leave-btn",
                closeModal: true
              }
            })
          }
        }).then((value) => {
          if (value === "add") {
            this.props.history.push({
              pathname: "/leave-tickets/add",
              state: {
                type: "Loss Of Pay",
                message: "Pending Leave"
              }
            });
          } else {
            window.location.reload();
          }
        });
      }
    }
  };

  handlePause = async () => {
    this.setState({ isLoading: true });
    try {

      const monthlyData = await Authapi.getMonthlyWorkHours(this.props.user.id);

      if (
        monthlyData &&
        monthlyData.hasOwnProperty('workingHoursAlertEnabled') &&
        monthlyData.workingHoursAlertEnabled === false
      ) {
        await this.proceedWithCheckout();
        return;
      }

      if (monthlyData && monthlyData.status) {
        const totalDurationToday = monthlyData.totalDurationToday || 0;


        let isInDynamicWindow = false;
        if (Object.prototype.hasOwnProperty.call(monthlyData, 'isCurrentSessionSevenToEight')) {
          isInDynamicWindow = !!monthlyData.isCurrentSessionSevenToEight;
        } else if (
          monthlyData &&
          (monthlyData.targetFullDayHours !== undefined && monthlyData.targetUpperHours !== undefined) &&
          typeof totalDurationToday === 'number'
        ) {
          const lower = Number(monthlyData.targetFullDayHours) * 3600;
          const upper = Number(monthlyData.targetUpperHours) * 3600;
          isInDynamicWindow = totalDurationToday >= lower && totalDurationToday < upper;
        } else {
          isInDynamicWindow = totalDurationToday >= 25200 && totalDurationToday < 28800;
        }

        if (isInDynamicWindow) {
          this.setState({ isLoading: false });

          const result = await swal({
            title: "Working hours alert!",
            text: `You are within your working hours alert window. Would you like to proceed with checkout?`,
            icon: "warning",
            buttons: {
              stayIn: { text: "STAY IN", value: "stayIn", className: "swal-stay-in-btn" },
              stayOut: { text: "STAY OUT", value: "stayOut", className: "swal-stay-out-btn" }
            },
            dangerMode: true
          });
          if (result === "stayIn") return;
          else if (result === "stayOut") await this.proceedWithCheckout();
        } else {
          await this.proceedWithCheckout();
        }
      } else {

        await this.proceedWithCheckout();
      }
    } catch (error) {

      await this.proceedWithCheckout();
    }
  };

  proceedWithCheckout = async () => {

    await new Promise(resolve => setTimeout(resolve, 2000));

    try {
      await Authapi.outTime();
      clearAutoTimerMode();
      clearAutoTimerRuntimeState();
      clearAutoTimerSessionStartedAt();
      this.setState({ isActive: false, stopTime: Date.now(), isLoading: false, autoTimerMode: "at_work" }, () => {
        workerTimers.clearInterval(this.countRef.current);

        toast.error("You marked OUT", { autoClose: 1500 });
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      });
    } catch (error) {
      this.setState({ isLoading: false });
      console.error("Error during checkout:", error);
    }
  };

  formatTime = () => {
    const { timer } = this.state;
    const getSeconds = `0${timer % 60}`.slice(-2);
    const minutes = Math.floor(timer / 60);
    const getMinutes = `0${minutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(timer / 3600)}`.slice(-2);
    return `${getHours} : ${getMinutes} : ${getSeconds}`;
  };

  formatTime1 = () => {
    const { totaltimer } = this.state;
    const getSeconds = `0${totaltimer % 60}`.slice(-2);
    const minutes = Math.floor(totaltimer / 60);
    const getMinutes = `0${minutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(totaltimer / 3600)}`.slice(-2);

    return `${getHours} : ${getMinutes} : ${getSeconds}`;
  };

  render() {
    if (this.state.isInitialLoading) {
      return <div className="stopwatch-card"><p className="timerText" style={{ marginLeft: "40px" }}>Loading...</p></div>;
    }

    return (


      <div className="stopwatch-card">
        <p className="timerText">{this.formatTime1()}</p>
        <div className="buttons">
          {!this.state.isActive && (
            <PremiumButton
              onClickFn={this.handleStart}
              btnText="IN"
              loading={this.state.isLoading}
              disabled={this.state.isLoading}
            />
          )}
          {this.state.isActive && (
            <PremiumButton
              onClickFn={this.handlePause}
              btnText="OUT"
              loading={this.state.isLoading}
              disabled={this.state.isLoading}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(Timer);
